export function getGraphQLVariable (variables, variableName, valuePropertyName = 'value', defaultValue = null) {
  if (variables && variableName) {
    const variable = variables.find(variable => variable.name === variableName)
    if (variable) {
      return variable[valuePropertyName]
    }
  }
  return defaultValue
}
